<template>
  <div>
    <b-progress
      :value="value"
      :min="STRENGTH.none"
      :max="STRENGTH.strong"
      class="password-strength-bar"
      :variant="strengthVariant"
    ></b-progress>
    <span
      class="password-strength-bar__description"
      :class="strengthStyle">
      {{strengthLevel}}
    </span>
  </div>
</template>
<style lang="sass" scoped>
  @import src/styles/defaults/variables
  @import "src/styles/defaults/mobile-first"

  .password-strength-bar
    max-height: 5px
    margin: 3px 0
    &__description
      text-transform: uppercase
      font-size: 0.9em
      &-strong
        color: $color-success
      &-medium
        color: $color-warning
      &-weak
        color: $color-danger
    +media-min-sm()
    +media-min-md()
    +media-min-lg()
</style>

<script>
import { STRENGTH } from '@/services/passwordStrengthCalculator';

export default {
  props: {
    value: Number,
  },
  data: () => ({
    STRENGTH,
  }),
  computed: {
    strengthLevel() {
      if (this.value === STRENGTH.weak) {
        return this.$t('login.password-strength.weak');
      }
      if (this.value === STRENGTH.medium) {
        return this.$t('login.password-strength.medium');
      }
      if (this.value === STRENGTH.strong) {
        return this.$t('login.password-strength.strong');
      }
      return this.$t('login.password-strength.weak');
    },
    strengthStyle() {
      return {
        'password-strength-bar__description-weak': this.value === STRENGTH.weak
          || this.value === STRENGTH.none,
        'password-strength-bar__description-medium': this.value === STRENGTH.medium,
        'password-strength-bar__description-strong': this.value === STRENGTH.strong,
      };
    },
    strengthVariant() {
      if (this.value === STRENGTH.weak) {
        return 'danger';
      }
      if (this.value === STRENGTH.medium) {
        return 'warning';
      }
      if (this.value === STRENGTH.strong) {
        return 'success';
      }
      return 'danger';
    },
  },
};
</script>
